import React, { useState } from 'react';
import c from 'classnames';
import { View } from '@uncinc/react-drupal-core';

import './style.scss';

const ParagraphBlockReference = ({ entity, className }) => {
  const [blockType, blockId] = entity.getIn(['field_block_reference', 0, 'target_id']).split('__');
  const [currentPage, setCurrentPage] = useState(0);

  // We only support view blocks for now.
  if (blockType === 'views_block') {
    // eslint-disable-next-line prefer-const
    const [viewId] = blockId.split('_', 1);
    const viewDisplay = blockId.replace(`${viewId}_`, '');

    return (
      <div className={c('Paragraph ParagraphBlockReference', className)}>
        <div className="ParagraphBlockReference__view">
          <View id={viewId} display={viewDisplay} page={currentPage} setCurrentPage={setCurrentPage} />
        </div>
      </div>
    );
  }

  return (
    <div className={`paragraph--block-reference ${className}`}>
      <p>Block id: {entity.getIn(['field_block_reference', 0, 'value'])}</p>
    </div>
  );
};

export default ParagraphBlockReference;
